import { Lock } from 'lucide-react';

/** Arrivé par un lien direct alors que l'option n'est pas activée pour l'officine. */
export default function OptionInactive() {
  return (
    <div className="flex-1 flex items-center justify-center p-8 bg-slate-100">
      <div className="max-w-md text-center rounded-2xl bg-white border border-slate-200 p-8 shadow-sm">
        <div className="mx-auto mb-4 w-12 h-12 rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center shadow-lg shadow-emerald-500/30">
          <Lock size={20} className="text-white" />
        </div>
        <h1 className="text-[18px] font-semibold text-slate-900">Gestion Sociale</h1>
        <p className="text-[13px] text-slate-600 mt-2 leading-relaxed">
          Cette option n’est pas activée pour votre pharmacie. Elle vous permet de remplir à l’écran la fiche
          d’identification de vos nouveaux salariés et de l’envoyer en PDF à votre service social.
        </p>
        <p className="text-[13px] text-slate-600 mt-3">
          Pour l’activer, contactez <b>PharmaGestion</b>.
        </p>
      </div>
    </div>
  );
}
